import type { Route } from '@angular/router';

import { ROUTE_SEGMENTS } from '@arya/shared/data-access';

import { DEV_SURFACE_ROUTES } from './dev-surfaces';
import { PLATFORM_BASE, PLATFORM_PATH } from './platform-path';

const DOCUMENTS_PATH = `${PLATFORM_PATH}/${ROUTE_SEGMENTS.account}/${ROUTE_SEGMENTS.documents}`;

const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: PLATFORM_PATH,
  },
  {
    path: 'admin',
    loadChildren: () => import('@arya/admin-shell/feature').then((m) => m.ADMIN_ROUTES),
  },
  {
    path: 'legal',
    loadChildren: () => import('@noxo/account/feature').then((m) => m.NOXO_PUBLIC_LEGAL_ROUTES),
  },
  { path: 'terms', redirectTo: 'legal/terms-and-conditions' },
  { path: 'risks', redirectTo: 'legal/risk-disclosure' },
  { path: 'complaints/policy', redirectTo: 'legal/complaints-policy' },
  { path: 'market/failure-rates', redirectTo: 'legal/failure-rates' },
  { path: 'account/contracts', redirectTo: DOCUMENTS_PATH },
  { path: 'account/contracts/:id', redirectTo: DOCUMENTS_PATH },
  {
    path: '',
    loadChildren: () => import('@noxo/auth/feature').then((m) => m.CONTACT_CHANGE_REVOKE_ROUTES),
  },
  {
    path: '',
    loadChildren: () => import('@noxo/auth/feature').then((m) => m.PANIC_FREEZE_ROUTES),
  },
  {
    path: 'print',
    loadChildren: () => import('@noxo/wallet/feature').then((m) => m.NOXO_PRINT_ROUTES),
  },
  {
    path: PLATFORM_PATH,
    loadChildren: async () => {
      const platform = await import('@arya/investment-platform/feature');
      return [
        {
          path: '',
          providers: [{ provide: platform.PLATFORM_BASE_PATH, useValue: PLATFORM_BASE }],
          loadChildren: () => platform.INVESTMENT_PLATFORM_ROUTES,
        },
      ];
    },
  },
  ...DEV_SURFACE_ROUTES,
  {
    path: '**',
    redirectTo: PLATFORM_PATH,
  },
];

export { appRoutes };
